import { render } from "./PreviousAndNextGame.vue?vue&type=template&id=5b4a4418&scoped=true"
import script from "./PreviousAndNextGame.vue?vue&type=script&lang=js"
export * from "./PreviousAndNextGame.vue?vue&type=script&lang=js"

import "./PreviousAndNextGame.vue?vue&type=style&index=0&id=5b4a4418&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b4a4418"]])

export default __exports__